import React, { useMemo } from "react";
import useThemeMode from "../../hooks/useThemeMode";
import { getMarketingTheme } from "../../utils/marketingTheme";

const ToolSeoFAQ = ({
  title = "Frequently asked questions",
  intro = "A few quick answers to common questions about this tool.",
  faqs = []
}) => {
  const { isDark } = useThemeMode();
  const colors = useMemo(() => getMarketingTheme(isDark), [isDark]);

  return (
    <section style={{ padding: "10px 20px 42px", background: colors.sectionBg }}>
      <div style={{ maxWidth: "1000px", margin: "0 auto" }}>
        <div style={{ textAlign: "center", marginBottom: "24px" }}>
          <h2
            style={{
              margin: "0 0 10px",
              color: colors.text,
              fontSize: "clamp(1.9rem, 4vw, 2.7rem)",
              lineHeight: "1.1"
            }}
          >
            {title}
          </h2>
          <p
            style={{
              margin: 0,
              color: colors.textMuted,
              fontSize: "16px",
              lineHeight: "1.7"
            }}
          >
            {intro}
          </p>
        </div>

        <div style={{ display: "grid", gap: "14px" }}>
          {faqs.map((faq) => (
            <div
              key={faq.question}
              style={{
                background: colors.cardBg,
                border: `1px solid ${colors.border}`,
                borderRadius: "20px",
                padding: "20px",
                boxShadow: colors.shadowSoft,
                backdropFilter: isDark ? "blur(12px)" : "none"
              }}
            >
              <h3
                style={{
                  margin: "0 0 10px",
                  color: colors.text,
                  fontSize: "18px",
                  lineHeight: "1.35"
                }}
              >
                {faq.question}
              </h3>
              <p
                style={{
                  margin: 0,
                  color: colors.textMuted,
                  fontSize: "15px",
                  lineHeight: "1.75"
                }}
              >
                {faq.answer}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ToolSeoFAQ;